/**
 * The payment-method consent the card step shows before redirecting to the provider (E23.9 D3).
 *
 * A VERBATIM copy of S3's `CONSENT_TEXT` (backend/app/core/services/payment_setup.py), with the
 * version the create call must send. No route serves the text, and adding one would be an API
 * change outside both S3's scope and this slice's, so the Console carries its own copy and a
 * test pins it: paymentConsent.test.js reads `CONSENT_TEXT_SHA256` from S3's own
 * tests/test_payment_consent_text.py and `payment_consent_version` from the backend settings,
 * so a wording change under OMEGA-954 turns this test red in the same commit that moves S3's.
 *
 * One array element per line, joined with "\n", because S3's source wraps its clauses with
 * line continuations that are not part of the text: each clause is ONE line. The wording is
 * OMEGA-954's to settle; edit it there first, never here alone.
 */

export const CONSENT_VERSION = "payment-method-terms-v1";

export const CONSENT_TEXT = [
  "You are adding a payment card so that Omega AI HPC can confirm your account and, once Auto Top-Up becomes available and you switch it on, buy prepaid credit for you.",
  "",
  "1. What credit is for. Workloads draw down a prepaid credit balance. Credit will be required before a workload can start.",
  "2. When we may charge this card. We do not charge this card today, and Auto Top-Up is not available yet. Once it is, and only if you switch it on, we may charge this card when your balance falls to the threshold you chose. We do not charge this card for anything else.",
  "3. How much. If you switch Auto Top-Up on, each charge will be the top-up amount you chose and nothing else, and it will buy that much credit.",
  "4. Your limits. We will not charge this card under Auto Top-Up until you have chosen a threshold and a top-up amount and a monthly ceiling is in place. When a ceiling is reached we stop charging and tell you.",
  "5. Switching it off. Auto Top-Up is off unless you switch it on, and you will be able to switch it off at any time from your billing settings. Credit you have already bought stays yours.",
  "6. Replacing your card. Replacing a saved card from the Console is not available yet. To change the card on file, contact support. When you replace it we will ask you to confirm this authorisation again for the new card.",
  "",
].join("\n");
